module.exports = __webpack_public_path__ + "img/1481480893.52b4e28b.jpg";